import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 24px;
  max-width: 640px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 160px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: #4f46e5;
  }
`;

const SubmitBtn = styled.button`
  margin-top: 16px;
  padding: 10px 24px;
  background: #4f46e5;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background: #4338ca;
  }
`;

const Feedback: React.FC = () => {
  const [comment, setComment] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!comment.trim()) return;
    setSent(true);
    setComment('');
  };

  return (
    <Container>
      <Title>Comments &amp; Feedback</Title>
      <p style={{ color: '#6b7280', marginBottom: 16 }}>
        Leave us your comments, suggestions, or report an issue.
      </p>
      {sent ? (
        <p style={{ color: '#059669', marginBottom: 16 }}>Thank you. Your feedback has been recorded.</p>
      ) : null}
      <form onSubmit={handleSubmit}>
        <TextArea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Type your comment here..."
          disabled={sent}
        />
        <SubmitBtn type="submit" disabled={!comment.trim() || sent}>
          {sent ? 'Sent' : 'Submit'}
        </SubmitBtn>
      </form>
    </Container>
  );
};

export default Feedback;
